<template>
  <div class="card modal-card" v-if="demande">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pd-5 overflow-y-scroll overflow-x-auto">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="isIntervention
                            ? 'demandeLogistique.creationOrUpdate.error.demandeUpdate' :
                            'editionDemandeImpression.error.demandeUpdate'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <a @click="handleClose">
        <b-icon class="icon is-pulled-right has-text-icon-more" icon="close" />
      </a>
      <span class="title is-size-3">
        {{ demandeCard.title }}
      </span>
      <div class="is-size-4 mgt-2">
        <span>{{ theme }}</span>
      </div>
      <query-tags-tag-input
        class="mgt-3"
        v-model="demande.tags"
        position="is-top"
        :tooltipLabel="$t('suiviProduction.card.detailCard.tagInfo')"
        field="tag"
        :moduleTag="moduleTag">
      </query-tags-tag-input>
      <div class="columns mgb-10px mgt-1 is-size-4">
        <div class="columns is-multiline column mgt-2">
          <router-link-blank
            v-if="annonceurs && (demande.ligneCommande || demande.devisCommande)"
            :message="annonceurs"
            :to="{
            name: 'c.bodac.commandes',
            params: { id: this.devisCommandeId }}"
            class="lien mgb-10px is-narrow column"
          />
          <div class="pd-10px is-narrow column">
            <b-tooltip v-if="assistantName !== ''"
              :label="$t('suiviProduction.card.detailCard.assistant')"
              position="is-right">
              <avatar
                :username="assistantName"
                :size="33"/>
            </b-tooltip>
          </div>
          <div class="pd-10px is-narrow column">
            <b-tooltip v-if="commercialName !== ''"
              :label="$t('suiviProduction.card.detailCard.commercial')"
              position="is-right">
              <avatar
                :username="commercialName"
                :size="33"/>
            </b-tooltip>
          </div>
          <span class="column is-narrow" v-if="demande.otTechniqueId">OT</span>
          <router-link-blank :to="{
            name: 'c.logistique.ordre_travail-tech',
            params: { id: demande.otTechniqueId }}"
            icon="open-in-new"
            v-if="demande.otTechniqueId"
            class=" pdr-10px column is-narrow"
            typeIcon="is-primary" sizeIcon="is-small">
          </router-link-blank>
          <multi-contact-intervenant
            :intervenant="annonceurComplet"
            class="column is-paddingless pdl-10px is-12 is-size-7"/>
        </div>
        <b-field :label="$t('suiviProduction.card.detailCard.dateLimite')"
                 class="column is-one-fifth mgb-10px is-size-4 column">
          <b-datepicker
            v-model="dateLimite"
            icon="calendar-today"
            position="is-bottom-left"
            nearby-selectable-month-days
            :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div>
        <b-field :label="$t('suiviProduction.card.detailCard.sujet')"
          :class="{ 'obligatoire': isIntervention }"
          class="mgl-3 overflow-y-scroll overflow-x-hidden is-max-height-130px">
          <b-input v-model="sujet"></b-input>
        </b-field>
        <b-field :label="$t('suiviProduction.card.detailCard.description')"
          class="mgl-3 overflow-y-scroll overflow-x-hidden is-max-height-130px">
          <b-input type="textarea" v-model="demande.description"
            :rows="2" custom-class="max-height-80"></b-input>
        </b-field>
        <b-field v-if="demande.campagne" :label="$t('suiviProduction.card.detailCard.visuelCamp')">
          <img :src="url" class="mgl-3 max-height-320" alt="Logo">
        </b-field>
        <gestion-message
          class="mgt-3"
          :elementId="demande.id"
          :title="$t('suiviProduction.card.detailCard.messages')"
          :module="constantes.MODULE_SUIVIPRODUCTION"
          @updateCount="updateCount"/>
      </div>
      <footer class="mgt-5">
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$emit('close')">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="handleClose">
              {{ $t('general.button.save') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script >
import { get as getIntervention, update as updateIntervention } from '@/api/logistique/demandeLogistique/index';
import { get as getImpression, update as updateImpression } from '@/api/logistique/demandeImpression/index';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import {
  DEMANDE_INTERVENTION_TYPE, MODULE_SUIVIPRODUCTION,
} from '@/configuration/logistique/suiviProduction/suiviProductionConfig';
import Avatar from 'vue-avatar';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { createNamespacedHelpers } from 'vuex';
import GestionMessage from '@/components/commun/gestionMessage/gestionMessage';
import formatDate from '@/services/general/formatIsoDate';
import messageSucces from '@/services/general/messageSucces';
import { cloneDeep } from 'lodash';
import queryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import {
  DEMANDE_IMPRESSION, DEMANDE_INTERVENTION,
} from '@/configuration/parametrage/tagConf';
import validation from '@/services/logistique/demandeImpression/validationDemandeImpression';
import validationUpdateDemande from '@/services/logistique/demandeLogistique/validation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/demandeImpression/translateDemandeImpression';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageErreur from '@/services/general/messageErreur';
import { getAllByElementId } from '@/api/pieceJointes';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popupSuiviProductionDetailCard',
  components: {
    errorMsgComponent,
    queryTagsTagInput,
    GestionMessage,
    RouterLinkBlank,
    Avatar,
    multiContactIntervenant,
  },
  props: {
    demandeCard: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      demande: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      dateLimite: null,
      error: false,
      attachement: null,
      constantes: {
        MODULE_SUIVIPRODUCTION,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    url() {
      return this.attachement?.cheminMin || this.attachement?.chemin || '/static/img/default-placeholder.png';
    },
    commercialName() {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find(u => u.id === this.commercialId);
      if (!userFound) return '';
      return nomPrenomGetter(userFound);
    },
    commercialId() {
      return this.isIntervention
        ? this.demande.ligneCommande?.commercialId
        : this.demande.devisCommande?.commercialId;
    },
    assistantId() {
      return this.isIntervention
        ? this.demande.ligneCommande?.assistantId
        : this.demande.devisCommande?.assistantId;
    },
    assistantName() {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find(u => u.id === this.assistantId);
      if (!userFound) return '';
      return nomPrenomGetter(userFound);
    },
    moduleTag() {
      return this.isIntervention
        ? DEMANDE_INTERVENTION
        : DEMANDE_IMPRESSION;
    },
    devisCommandeId() {
      return this.isIntervention
        ? this.demande.ligneCommande.devisCommandeId
        : this.demande.devisCommande.id;
    },
    theme() {
      return this.isIntervention
        ? this.demande.ligneCommande?.theme
        : this.demande.devisCommande?.theme;
    },
    annonceurs() {
      return this.isIntervention
        ? this.demande.ligneCommande?.allAnnonceurs.map(a => a.nomCommercial).join(', ')
        : this.demande.client.nomCommercial;
    },
    annonceurComplet() {
      return this.isIntervention
        ? this.demande.ligneCommande?.allAnnonceurs[0]
        : this.demande.devisCommande.intervenants.find(inter => {
          return inter.annonceur;
        });
    },
    sujet: {
      get() {
        return this.isIntervention
          ? this.demande.actionLogistique
          : this.demande.commentaire;
      },
      set(value) {
        if (this.isIntervention) this.demande.actionLogistique = value;
        else this.demande.commentaire = value;
      },
    },
    isIntervention() {
      return this.demandeCard.type === DEMANDE_INTERVENTION_TYPE;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    formatDate,
    formatDemandeBeforeUpdate(newDemande) {
      newDemande.dateLimite = formatDate(this.dateLimite);
      newDemande.tags.forEach(tag => {
        const infosTag = this.parametre(PARAMETRES_KEYS.tag).find(tagId => tag.tagId === tagId.id);
        if (infosTag) {
          tag.tag = infosTag;
        }
      });
    },
    async loadAttachement() {
      const attachementLoaded = (await getAllByElementId(this.demande.campagneId)).data.result.items
        .find((image) => image.placeType === 'Logo');
      this.attachement = attachementLoaded ?? null;
    },
    updateCount(count) {
      this.demandeCard.nbMessage = count;
    },
    async handleSave() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const newDemande = cloneDeep(this.demande);
        this.formatDemandeBeforeUpdate(newDemande);
        if (this.isIntervention) {
          await updateIntervention(newDemande);
        } else {
          await updateImpression(newDemande);
        }
        this.demandeCard.dateLimite = newDemande.dateLimite;
        this.demandeCard.tags = newDemande.tags;
        if (this.isIntervention) {
          this.demandeCard.sujet = this.demande.actionLogistique;
        } else {
          this.demandeCard.sujet = this.demande.commentaire;
        }
        this.demandeCard.description = this.demande.description;
        messageSucces(this.$i18n.t('suiviProduction.card.detailCard.updateSuccess'));
        this.$emit('close');
      } catch (e) {
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        if (this.isIntervention) {
          validationUpdateDemande(e.response, this.messages);
        } else {
          validation(e.response, this.messages);
        }
        validationGeneral(this.$i18n, e.response, this.champsVide,
          this.messages, this.messagesChampsVide, translate);
        this.error = true;
      } finally {
        loadingComponent.close();
      }
    },
    async handleClose() {
      await this.handleSave();
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.tag]);
      this.demande = this.isIntervention
        ? (await getIntervention(this.demandeCard.id)).data.result
        : (await getImpression(this.demandeCard.id)).data.result;
      this.dateLimite = this.demande.dateLimite ? new Date(this.demande.dateLimite) : null;
      if (this.demande.campagne) {
        await this.loadAttachement();
      }
    } catch (e) {
      messageErreur(this.$i18n);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
